import axios from 'axios';

import { settings } from './settings';
import { AuthenticationAPI } from './api';

const API = {
  auth: new AuthenticationAPI(),
};

class Auth {
  constructor() {
    this.token = localStorage.getItem('idToken');
    this.expiresIn = localStorage.getItem('expiresIn');
    this.timezone = localStorage.getItem('timezone');
    this.ip = localStorage.getItem('ip');
    this.person_id = localStorage.getItem('person_id');
    this.token_id = localStorage.getItem('token_id');
    this.token_expires = localStorage.getItem('token_expires');
    try {
      this.payload = JSON.parse(localStorage.getItem('idTokenPayload') || '{}');
    } catch (e) {
      this.payload = {};
    }
    this.setHeaders();
  }

  setHeaders() {
    if (this.token !== null) {
      axios.defaults.headers.common.Authorization = `Bearer ${this.token}`;
    } else {
      delete (axios.defaults.headers.common.Authorization);
    }
  }

  isAuthenticated() {
    if (this.token) {
      return true;
    }
    return false;
  }

  login(obj = {}) {
    const {
      timezone,
      ip,
      person_id,
      token_id,
      token_expires,
    } = obj;
    localStorage.setItem('timezone', timezone);
    localStorage.setItem('ip', ip);
    localStorage.setItem('person_id', person_id);
    localStorage.setItem('token_id', token_id);
    localStorage.setItem('token_expires', token_expires);
    this.timezone = timezone;
    this.ip = ip;
    this.person_id = person_id;
    this.token_id = token_id;
    this.token_expires = token_expires;
  }

  logout() {
    this.token = null;
    this.payload = {};
    this.expiresIn = null;
    this.person_id = null;
    this.token_id = null;
    this.token_expires = null;
    this.ip = null;
    this.timezone = null;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('idTokenPayload');
    localStorage.removeItem('expiresIn');
    localStorage.removeItem('timezone');
    localStorage.removeItem('ip');
    localStorage.removeItem('person_id');
    localStorage.removeItem('token_id');
    localStorage.removeItem('token_expires');
    this.setHeaders();
    settings.clear();
    return API.auth.logout().catch((error) => {
      console.error('Unable to log out');
      console.error(error);
    });
  }
}

export const auth = new Auth();

window.auth = auth; // @debug



// WEBPACK FOOTER //
// ./src/lib/auth.js